var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-layout-box"},[_c('left-menu'),_c('div',{staticClass:"manage-layout-sub-box"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }